import { useEffect, useRef } from 'react';
import { createReconnectingWebSocket, setCloseWebSocket } from '../utils';
import { getItem } from '../tools';
import { useNotification } from './useNotification';
import {ackNotification} from "../api";

const NotificationListener = ({ userId }) => {
    const wsControlRef = useRef(null);
    const { notify } = useNotification();

    useEffect(() => {
        if (!userId) return;

        const wsControl = createReconnectingWebSocket({
            userId,
            getToken: () => getItem('token') || '',
            onMessage: (event) => {
                try {
                    const data = JSON.parse(event.data);

                    notify({
                        title: data.title || 'Received notification',
                        description: data.content,
                        onAcknowledge: async () => {
                            await ackNotification(data.id);
                        },
                    });
                } catch (e) {
                    // Failed to parse message
                }
            },
            onOpen: () => {},
            onClose: () => {},
            onError: (err) => {
                // WebSocket error
            },
        });

        wsControlRef.current = wsControl;

        setCloseWebSocket(() => {
            wsControlRef.current?.close();
        });

        return () => {
            wsControl?.close();
        };
    }, [userId, notify]); // 注意这里加了 notify 作为依赖

    return null;
};

export default NotificationListener;
